import Vue from 'vue'
import Router from 'vue-router'
import OverallLayout from '@/views/Layout' //整體layout
import BackLayout from '@/views/Backstage/Layout' //backstage 整體layout
import {
  getLocalUserInfo,
  setLocalUserInfo,
  removeLocalUserInfo,
  setPermission,
  isUpdatePermission
} from "@/models/HELPERS/common.js";

/**************************** 前台 ****************************/
import Login from '@/views/Home/Login' //登入


/**************************** 總後台 ****************************/
import BackYfLayout from '@/views/Backstage/yf/Layout' // 後台yf layout
import YfDashboard from '@/views/Backstage/yf/dashboard' // 總後台儀錶板

// 契約管理
import Contract from '@/views/Backstage/yf/contract' // 契約
import ContractPromotionSetting from '@/views/Backstage/yf/contractPromotionSetting' // 契約促銷設定
import ContractNotice from '@/views/Backstage/yf/contractNotice' // 通知書

// 業務管理
import Business from '@/views/Backstage/yf/business' // 業務
import BusinessOrganizationTree from '@/views/Backstage/yf/businessOrganizationTree' // 業務上層組織樹
import BusinessEquityV2 from '@/views/Backstage/yf/businessEquityV2' // 每期業務權益2.0總表

// 帳單管理
import UnpaidBills from '@/views/Backstage/yf/unpaidBills' // 未繳帳單
import PayDetails from '@/views/Backstage/yf/payDetails' // 繳費細項
import BillingSettings from '@/views/Backstage/yf/billingSettings' // 帳單設定
import CurrentMonthBill from '@/views/Backstage/yf/currentMonthBill' // 當月全部帳單

// 理賠
import UnProcessedMutualAidMoney from '@/views/Backstage/yf/unProcessedMutualAidMoney' // 未處理互助金
import ClaimedAidFund from '@/views/Backstage/yf/claimedAidFund' // 已理賠互助金
import DeceasedClaimForm from '@/views/Backstage/yf/deceasedClaimForm' // 身故請領表

// 報表
import ExportClaim from '@/views/Backstage/yf/exportClaim' // 匯出理賠
import PaidReport from '@/views/Backstage/yf/paidReport' // 查詢已繳費
import MonthlyNewUserReport from '@/views/Backstage/yf/monthlyNewUserReport' // 每月新增人數
import MonthlyDeceasedClaimsReport from '@/views/Backstage/yf/monthlyDeceasedClaimsReport' // 每月身故理賠人數
import MonthlyFullPaymentCount from '@/views/Backstage/yf/monthlyFullPaymentCount' // 每月繳滿人數
import RegionalDataReport from '@/views/Backstage/yf/regionalDataReport' // 地區相關數據
import BillDataReport from '@/views/Backstage/yf/billDataReport' // 帳單相關數據
import MonthlyCount from '@/views/Backstage/yf/monthlyCount' // 每月件數
import MemberAgeDistribution from '@/views/Backstage/yf/memberAgeDistribution' // 互助人年齡層分布
import SalesAgeDistribution from '@/views/Backstage/yf/salesAgeDistribution' // 業務年齡層分布
import MemberExclusionPaycount from '@/views/Backstage/yf/memberExclusionPaycount' // 失效會員繳款次數
import DeathMemberClaim from '@/views/Backstage/yf/deathMemberClaim' // 身故會員理賠
import ExportReport from '@/views/Backstage/yf/exportReport' // 匯出報表

//設定
import Config from '@/views/Backstage/yf/config' // 環境設定
import SecurityCenter from '@/views/Backstage/yf/securityCenter' // 安全中心
import FrontendDataSetup from '@/views/Backstage/yf/frontendDataSetup' // 前台數據設定
import PermissionSettings from '@/views/Backstage/yf/permissionSettings' // 權限設定

// 操作日誌
import ContractLog from '@/views/Backstage/yf/contractLog' // 契約LOG
import BusinessLog from '@/views/Backstage/yf/businessLog' // 業務LOG
import BillLog from '@/views/Backstage/yf/billLog' // 帳單LOG

// 舊系統-操作日誌
import OldSystemContractLog from '@/views/Backstage/yf/oldSystemContractLog' // 舊系統-契約LOG
import OldSystemContractPayNoticeAddressLog from '@/views/Backstage/yf/oldSystemContractPayNoticeAddressLog' // 舊系統-查詢契約繳費通知地址LOG
import OldSystemJoinMemberFeeLog from '@/views/Backstage/yf/oldSystemJoinMemberFeeLog' // 舊系統-入會費LOG
import OldSystemAmountLog from '@/views/Backstage/yf/oldSystemAmountLog' // 舊系統-互助金LOG
import OldSystemSalesLog from '@/views/Backstage/yf/oldSystemSalesLog' // 舊系統-業務LOG

/**************************** 要助人後台 ****************************/
import BackToHelpingOthersLayout from '@/views/Backstage/toHelpingOthers/Layout' // 後台pay layout
import ToHelpingOthersDashboard from '@/views/Backstage/toHelpingOthers/dashboard' // 要助人後台儀錶板
import ToHelpingOthersInformation from '@/views/Backstage/toHelpingOthers/information' // 要助人資料
import ToHelpingOthersContract from '@/views/Backstage/toHelpingOthers/contract' // 契約
import Pay from '@/views/Backstage/toHelpingOthers/pay' // 繳費


/**************************** 業務人後台 ****************************/
import BackBusinessInfoLayout from '@/views/Backstage/businessInfo/Layout' // 後台pay layout
import BusinessInfoDashboard from '@/views/Backstage/businessInfo/dashboard' // 業務人後台儀錶板
import BusinessInfoInformation from '@/views/Backstage/businessInfo/information' // 業務人資料
import BusinessInfoContract from '@/views/Backstage/businessInfo/contract' // 直接契約
import BusinessInfoReturnPiece from '@/views/Backstage/businessInfo/returnPiece' // 直接回歸件
import BusinessInfoOrganizationTree from '@/views/Backstage/businessInfo/organizationTree' // 組織樹


/**************************** PDF TEST ****************************/
import MembershipCard from '@/components/common/PrintTemplate/MembershipCard'; // 會員證
import SignReceipt from '@/components/common/PrintTemplate/SignReceipt'; // 簽收回條
import BusinessCertificate from '@/components/common/PrintTemplate/BusinessCertificate'; // 業務證
import PaymentSchedule from '@/components/common/PrintTemplate/PaymentSchedule'; // 給付明細表
import NormalPaymentFullNotice from '@/components/common/PrintTemplate/NormalPaymentFullNotice'; // 額滿通知函
import PaymentReminderNotice from '@/components/common/PrintTemplate/PaymentReminderNotice'; // 催繳通知書

Vue.use(Router);

// 需要權限判斷路由
let auth_routes = [
  {
    path: 'contract',
    name: 'Contract',
    component: Contract,
    meta: {
      title: '契約',
      permission: [],
      authority: 1,
      parent_tag: 'contract_management',
      permission_tag: ['contract']
    }
  },
  {
    path: 'contractPromotionSetting',
    name: 'ContractPromotionSetting',
    component: ContractPromotionSetting,
    meta: {
      title: '契約促銷設定',
      permission: [],
      authority: 1,
      parent_tag: 'contract_management',
      permission_tag: ['contract_promotion_setting']
    }
  },
  {
    path: 'contractNotice',
    name: 'ContractNotice',
    component: ContractNotice,
    meta: {
      title: '通知書',
      permission: [],
      authority: 1,
      parent_tag: 'contract_management',
      permission_tag: ['notice']
    }
  },
  {
    path: 'business',
    name: 'Business',
    component: Business,
    meta: {
      title: '業務',
      permission: [],
      authority: 1,
      parent_tag: 'business_management',
      permission_tag: ['business']
    }
  },
  {
    path: 'businessOrganizationTree',
    name: 'BusinessOrganizationTree',
    component: BusinessOrganizationTree,
    meta: {
      title: '業務上層組織樹',
      permission: [],
      authority: 1,
      parent_tag: 'business_management',
      permission_tag: ['business_organization_tree']
    }
  },
  {
    path: 'businessEquityV2',
    name: 'BusinessEquityV2',
    component: BusinessEquityV2,
    meta: {
      title: '每期業務權益2.0總表',
      permission: [],
      authority: 1,
      parent_tag: 'business_management',
      permission_tag: ['business_equity_V2']
    }
  },
  {
    path: 'unpaidBills',
    name: 'UnpaidBills',
    component: UnpaidBills,
    meta: {
      title: '未繳帳單',
      permission: [],
      authority: 1,
      parent_tag: 'bill_management',
      permission_tag: ['unpaid_bills']
    }
  },
  {
    path: 'payDetails',
    name: 'PayDetails',
    component: PayDetails,
    meta: {
      title: '繳費細項',
      permission: [],
      authority: 1,
      parent_tag: 'bill_management',
      permission_tag: ['pay_details']
    }
  },
  {
    path: 'billingSettings',
    name: 'BillingSettings',
    component: BillingSettings,
    meta: {
      title: '帳單設定',
      permission: [],
      authority: 1,
      parent_tag: 'bill_management',
      permission_tag: ['billing_settings']
    }
  },
  {
    path: 'currentMonthBill',
    name: 'CurrentMonthBill',
    component: CurrentMonthBill,
    meta: {
      title: '當月全部帳單',
      permission: [],
      authority: 1,
      parent_tag: 'bill_management',
      permission_tag: ['current_month_bill']
    }
  },
  {
    path: 'unProcessedMutualAidMoney',
    name: 'UnProcessedMutualAidMoney',
    component: UnProcessedMutualAidMoney,
    meta: {
      title: '未處理互助金',
      permission: [],
      authority: 1,
      parent_tag: 'claims',
      permission_tag: ['unprocessed_mutual_aid_money']
    }
  },
  {
    path: 'claimedAidFund',
    name: 'ClaimedAidFund',
    component: ClaimedAidFund,
    meta: {
      title: '已理賠互助金',
      permission: [],
      authority: 1,
      parent_tag: 'claims',
      permission_tag: ['claimed_aid_fund']
    }
  },
  {
    path: 'deceasedClaimForm',
    name: 'DeceasedClaimForm',
    component: DeceasedClaimForm,
    meta: {
      title: '身故請領表',
      permission: [],
      authority: 1,
      parent_tag: 'claims',
      permission_tag: ['deceased_claim_form']
    }
  },
  {
    path: 'exportClaim',
    name: 'ExportClaim',
    component: ExportClaim,
    meta: {
      title: '匯出理賠',
      permission: [],
      authority: 1,
      parent_tag: 'claims',
      permission_tag: ['export_claim']
    }
  },
  {
    path: 'paidReport',
    name: 'PaidReport',
    component: PaidReport,
    meta: {
      title: '查詢已繳費-報表',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['paid_report']
    }
  },
  {
    path: 'monthlyNewUserReport',
    name: 'MonthlyNewUserReport',
    component: MonthlyNewUserReport,
    meta: {
      title: '每月新增人數',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['monthly_new_user_report']
    }
  },
  {
    path: 'monthlyDeceasedClaimsReport',
    name: 'MonthlyDeceasedClaimsReport',
    component: MonthlyDeceasedClaimsReport,
    meta: {
      title: '每月身故理賠人數',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['monthly_deceased_user_report']
    }
  },
  {
    path: 'deathMemberClaim',
    name: 'DeathMemberClaim',
    component: DeathMemberClaim,
    meta: {
      title: '身故會員理賠分布',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['death_member_claim']
    }
  },
  {
    path: 'monthlyFullPaymentCount',
    name: 'MonthlyFullPaymentCount',
    component: MonthlyFullPaymentCount,
    meta: {
      title: '每月繳滿人數',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['monthly_full_payment_count']
    }
  },
  {
    path: 'regionalDataReport',
    name: 'RegionalDataReport',
    component: RegionalDataReport,
    meta: {
      title: '地區相關數據',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['regional_data_report']
    }
  },
  {
    path: 'billDataReport',
    name: 'BillDataReport',
    component: BillDataReport,
    meta: {
      title: '帳單相關數據',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['bill_data_report']
    }
  },
  {
    path: 'monthlyCount',
    name: 'MonthlyCount',
    component: MonthlyCount,
    meta: {
      title: '每月件數',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['monthly_count_report']
    }
  },
  {
    path: 'memberAgeDistribution',
    name: 'MemberAgeDistribution',
    component: MemberAgeDistribution,
    meta: {
      title: '互助人年齡層分布',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['member_age_distribution_report']
    }
  },
  {
    path: 'salesAgeDistribution',
    name: 'SalesAgeDistribution',
    component: SalesAgeDistribution,
    meta: {
      title: '業務年齡層分布',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['sales_age_distribution_report']
    }
  },
  {
    path: 'memberExclusionPaycount',
    name: 'MemberExclusionPaycount',
    component: MemberExclusionPaycount,
    meta: {
      title: '失效會員繳款次數',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['member_exclusion_paycount']
    }
  },
  {
    path: 'exportReport',
    name: 'ExportReport',
    component: ExportReport,
    meta: {
      title: '匯出報表',
      permission: [],
      authority: 1,
      parent_tag: 'report',
      permission_tag: ['export_report']
    }
  },
  {
    path: 'config',
    name: 'Config',
    component: Config,
    meta: {
      title: '環境設定',
      permission: [],
      authority: 1,
      parent_tag: 'set',
      permission_tag: ['config']
    }
  },
  {
    path: 'securityCenter',
    name: 'SecurityCenter',
    component: SecurityCenter,
    meta: {
      title: '安全中心',
      permission: [],
      authority: 1,
      parent_tag: 'set',
      permission_tag: ['security_center']
    }
  },
  {
    path: 'frontendDataSetup',
    name: 'FrontendDataSetup',
    component: FrontendDataSetup,
    meta: {
      title: '前台數據設定',
      permission: [],
      authority: 1,
      parent_tag: 'set',
      permission_tag: ['frontend_data_setup']
    }
  },
  {
    path: 'permissionSettings',
    name: 'PermissionSettings',
    component: PermissionSettings,
    meta: {
      title: '權限設定',
      permission: [],
      authority: 1,
      parent_tag: 'set',
      permission_tag: ['permission_settings']
    }
  },
  {
    path: 'contractLog',
    name: 'ContractLog',
    component: ContractLog,
    meta: {
      title: '契約LOG',
      permission: [],
      authority: 1,
      parent_tag: 'log',
      permission_tag: ['contract_log']
    }
  },
  {
    path: 'businessLog',
    name: 'BusinessLog',
    component: BusinessLog,
    meta: {
      title: '業務LOG',
      permission: [],
      authority: 1,
      parent_tag: 'log',
      permission_tag: ['business_log']
    }
  },
  {
    path: 'billLog',
    name: 'billLog',
    component: BillLog,
    meta: {
      title: '帳單LOG',
      permission: [],
      authority: 1,
      parent_tag: 'log',
      permission_tag: ['bill_log']
    }
  },
  {
    path: 'oldSystemContractLog',
    name: 'OldSystemContractLog',
    component: OldSystemContractLog,
    meta: {
      title: '舊系統-契約LOG',
      permission: [],
      authority: 1,
      parent_tag: 'old_system_log',
      permission_tag: ['old_system_contract_log']
    },
  },
  {
    path: 'oldSystemContractPayNoticeAddressLog',
    name: 'OldSystemContractPayNoticeAddressLog',
    component: OldSystemContractPayNoticeAddressLog,
    meta: {
      title: '舊系統-查詢契約繳費通知地址LOG',
      permission: [],
      authority: 1,
      parent_tag: 'old_system_log',
      permission_tag: ['old_system_contract_pay_notice_address_log']
    }
  },
  {
    path: 'oldSystemJoinMemberFeeLog',
    name: 'OldSystemJoinMemberFeeLog',
    component: OldSystemJoinMemberFeeLog,
    meta: {
      title: '舊系統-入會費LOG',
      permission: [],
      authority: 1,
      parent_tag: 'old_system_log',
      permission_tag: ['old_system_join_member_fee_log']
    },
  },
  {
    path: 'oldSystemAmountLog',
    name: 'OldSystemAmountLog',
    component: OldSystemAmountLog,
    meta: {
      title: '舊系統-互助金LOG',
      permission: [],
      authority: 1,
      parent_tag: 'old_system_log',
      permission_tag: ['old_system_amount_log']
    },
  },
  {
    path: 'oldSystemSalesLog',
    name: 'OldSystemSalesLog',
    component: OldSystemSalesLog,
    meta: {
      title: '舊系統-業務LOG',
      permission: [],
      authority: 1,
      parent_tag: 'old_system_log',
      permission_tag: ['old_system_sales_log']
    },
  },
]

// 組合路由(權限 & 必要)
const combination_route = [
  {
    path: '/',
    redirect: to => {
      // 解析第二個和第三個 '/' 之間的字串
      const path = to.path;
      const regex = /\/[^\/]*\/([^\/]*)\//;
      const match = path.match(regex);

      // 根據 URL 的查詢參數來決定重定向的目標
      const redirect_path = {
        yf: '/backstage/yf/dashboard',
        toHelpingOthers: '/backstage/toHelpingOthers/dashboard',
        businessInfo: '/backstage/businessInfo/dashboard'
      }

      const target = match ? redirect_path[match[1]] : '/login'

      return target;
    }
  },
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'OverallLayout',
    component: OverallLayout,
    meta: {
      title: '整體layout',
      permission: ['search']
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
          title: '登入',
          permission: ['search']
        }
      },
      {
        path: '/backstage',
        redirect: '/backstage/yf/dashboard',
        name: 'BackLayout',
        component: BackLayout,
        meta: {
          title: 'backstage 整體layout',
          permission: ['search']
        },
        children: [
          {
            path: 'yf',
            redirect: '/backstage/yf/dashboard',
            name: 'BackYfLayout',
            component: BackYfLayout,
            meta: {
              title: '後台yf layout',
              permission: ['search'],
              authority: 1
            },
            children: [
              {
                path: 'dashboard',
                name: 'YfDashboard',
                component: YfDashboard,
                meta: {
                  title: '儀錶板',
                  permission: ['search'],
                  authority: 1
                }
              },
              ...auth_routes
            ]
          },
          {
            path: 'toHelpingOthers',
            redirect: '/backstage/toHelpingOthers/dashboard',
            name: 'BackToHelpingOthersLayout',
            component: BackToHelpingOthersLayout,
            meta: {
              title: '後台toHelpingOthers layout',
              permission: ['search'],
              authority: 2
            },
            children: [{
                path: 'dashboard',
                name: 'ToHelpingOthersDashboard',
                component: ToHelpingOthersDashboard,
                meta: {
                  title: '儀錶板',
                  permission: ['search'],
                  authority: 2
                }
              },
              {
                path: 'information',
                name: 'ToHelpingOthersInformation',
                component: ToHelpingOthersInformation,
                meta: {
                  title: '要助人資料',
                  permission: ['search'],
                  authority: 2
                }
              },
              {
                path: 'contract',
                name: 'ToHelpingOthersContract',
                component: ToHelpingOthersContract,
                meta: {
                  title: '契約',
                  permission: ['search'],
                  authority: 2
                }
              },
              {
                path: 'pay',
                name: 'Pay',
                component: Pay,
                meta: {
                  title: '繳費',
                  permission: ['search'],
                  authority: 2
                }
              },
            ]
          },
          {
            path: 'businessInfo',
            redirect: '/backstage/businessInfo/dashboard',
            name: 'BackBusinessInfoLayout',
            component: BackBusinessInfoLayout,
            meta: {
              title: '後台businessInfo layout',
              permission: ['search'],
              authority: 3
            },
            children: [{
                path: 'dashboard',
                name: 'BusinessInfoDashboard',
                component: BusinessInfoDashboard,
                meta: {
                  title: '儀錶板',
                  permission: ['search'],
                  authority: 3
                }
              },
              {
                path: 'information',
                name: 'BusinessInfoInformation',
                component: BusinessInfoInformation,
                meta: {
                  title: '業務人資料',
                  permission: ['search'],
                  authority: 3
                }
              },
              {
                path: 'contract',
                name: 'BusinessInfoContract',
                component: BusinessInfoContract,
                meta: {
                  title: '直推契約',
                  permission: ['search'],
                  authority: 3
                }
              },
              {
                path: 'returnPiece',
                name: 'BusinessInfoReturnPiece',
                component: BusinessInfoReturnPiece,
                meta: {
                  title: '直推回歸件',
                  permission: ['search'],
                  authority: 3
                }
              },
              {
                path: 'organizationTree',
                name: 'BusinessInfoOrganizationTree',
                component: BusinessInfoOrganizationTree,
                meta: {
                  title: '組織樹',
                  permission: ['search'],
                  authority: 3
                }
              },
            ]
          }
        ]
      }
    ],
  }
];

const router = new Router({
  mode: 'history',
  base: `${process.env.VUE_APP_BASE_URL}`,
  routes: combination_route
});


router.beforeEach((to, from, next) => {
  const info = getLocalUserInfo(to.meta.authority);

  if (info && info.permission && info.authority === 1) {
    setPermission(auth_routes, info.permission);
  }

  console.log(auth_routes);
  // 頁面驗證
  if (!to.meta.permission.includes('search')) {
    if ((!info || info === null)) {
      removeLocalUserInfo(to.meta.authority);

      next({
        path: '/login',
      });
    } else if (to.matched.some(item => !item.meta.permission.includes('search'))) {
      next({
        path: '/backstage/yf/dashboard',
      });
    } else {
      next();
    }

  } else {
    next();
  }

  next();
});

const defaultTitle = '永豐網路平台'; //默認title

router.afterEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle //動態更改title

  const info = getLocalUserInfo(to.meta.authority);

  if (info) {
    const is_updata = isUpdatePermission(to.meta, info.permission);
    const save_data = {
      ...info,
      is_updata: is_updata
    }

    setLocalUserInfo(to.meta.authority, save_data);
  }

})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js